import { createSelector } from 'reselect';
import moment from 'moment';

const getOrdersStartDate = state => state.orders.ordersStartDate;
const getOrdersEndDate = state => state.orders.ordersEndDate;
const getOrders = state => state.orders.orders;
const getLastUpdate = state => state.orders.lastUpdate;

export const getVisibleOrders = createSelector(
  [getOrdersStartDate, getOrdersEndDate, getOrders, getLastUpdate],
  (ordersStartDate, ordersEndDate, orders) =>
    orders.filter(o => moment(o.pickupTimeNumeric).isAfter(moment(ordersStartDate)) && moment(o.pickupTimeNumeric).isBefore(moment(ordersEndDate))),
);

export default getVisibleOrders;
